import React, { useState, useEffect, Fragment } from 'react'
import { Navbar, DilanComponents } from '../../components'

const Dilan = () => {
	return (
		<Fragment>
			<Navbar />
			<DilanComponents />
		</Fragment>
	)
}

export default Dilan